import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField/TextField";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import {Translate} from "../../../../config/Translate";
import Grid from "@material-ui/core/Grid";
import SubTitle from "../../../components/elements/SubTitle";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import ProtectedFileUploader from "../../fileManager/Components/ProtectedFileUploader";
import {defaultVariabls} from "../../../../config";
import Button from "@material-ui/core/Button/Button";
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import FieldCounterWithoutBar from "../../../components/elements/FieldCounterWithoutBar";
import Typography from "@material-ui/core/Typography/Typography";
import Alert from "@material-ui/lab/Alert/Alert";
import GetConfirmationText from "../../../components/elements/GetConfirmationText";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

class EpisodeMaker extends React.Component {
    state = {
        episodes: !!this.props.episodes.length ? this.props.episodes :
            [
                {
                    name: (this.props.physically === "ebook" ? Translate.chapter : Translate.episode) +" 1",
                    orders: 1,
                    description:'',
                    thumbnail:'',
                    file:''
                }
            ],
        can_add:false,
        loading:false
    };
    classes = this.props.classes;

    async handleInput(index,input,field){
        let {episodes} = this.state;
        if(field === "orders"){
            input = Math.abs(parseInt(input))
        }
        episodes[index][field] = input;
        if(field === "file"){
            await this.setState({
                loading:true
            })
        }
        await this.setState({
            episodes
        })
        if(field === "file"){
            await this.setState({
                loading:false
            })
        }
        await this.props.handleEpisodes(episodes);
    }
    handleAddNewEP(){
        let {episodes} = this.state;
        if(!episodes[episodes.length - 1] || !!episodes[episodes.length - 1]?.file){
            episodes.push(
                {
                    name: (this.props.physically === "ebook" ? Translate.chapter : Translate.episode) +" " + (parseInt(episodes.length)+1),
                    orders: parseInt(episodes.length) + 1 ,
                    description:'',
                    thumbnail:'',
                    file:''
                }
            )
            this.setState({
                episodes
            })
        }else{
            this.props.enqueueSnackbar(Translate.pleaseAddPreviousEpFile, {
                variant: 'warning',
            });
        }

    }
    async handleRemoveEp(index){
        await this.setState({
            loading:true
        })
        let {episodes} = this.state;
        await episodes.splice(index, 1);
        await this.setState({
            episodes,
            loading:false
        })
        await this.props.handleEpisodes(episodes);
    }
    render(){
        let {episodes,loading} = this.state;
        let {physically} = this.props;
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SubTitle align="left">{physically === "ebook" ? Translate.chapters : Translate.episodes}</SubTitle>
                </Grid>

                {
                    !!loading ? <AppCardLoaderFields/> :
                    episodes.map((episode,index) => (
                        <Grid item xs={12} key={index} className="ep-maker-holder">
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={9}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            {
                                                physically === "ebook" ?
                                                    <ProtectedFileUploader
                                                        index={index}
                                                        handleFile={(file) => this.handleInput(index,file,'file')}
                                                        title={Translate.epubFile}
                                                        type="epub"
                                                        variant="outlined"
                                                        color="secondary"
                                                    />
                                                    :
                                                    <ProtectedFileUploader
                                                        index={index}
                                                        handleFile={(file) => this.handleInput(index,file,'file')}
                                                        title={Translate.epAudioFile}
                                                        type="audio"
                                                        variant="outlined"
                                                        color="secondary"
                                                    />
                                            }
                                            {
                                                physically === "audiobook" &&
                                                <Typography style={{marginTop:10}}>{Translate.audioFormats}</Typography>
                                            }
                                        </Grid>
                                        {
                                            !!episode.file &&
                                            <Grid item xs={12}>
                                                {
                                                    physically === "ebook" ?
                                                        <Button
                                                            size="small"
                                                            color="primary"
                                                            component="a"
                                                            target="_blank"
                                                            href={`${defaultVariabls.website}/file/get-ebook/${episode.file.id}.${episode.file.extension}?token=${episode.file.token}`}
                                                        >
                                                            {Translate.epubFileDL}
                                                        </Button>
                                                    :
                                                    <audio
                                                        controls
                                                    >
                                                        <source src={`${defaultVariabls.website}/file/get-audio/${episode.file.id}?token=${episode.file.token}`} type={`audio/${episode.file.extension}`} />
                                                        Your browser does not support the audio element.
                                                    </audio>
                                                }
                                            </Grid>
                                        }
                                        <Grid item xs={4}>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                variant="outlined"
                                                label={Translate.index_number}
                                                type="number"
                                                value={episode.orders}
                                                onChange={(e) => this.handleInput(index,e.target.value,'orders')}
                                            />
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                variant="outlined"
                                                label={physically === "ebook" ? Translate.chapterName : Translate.epName}
                                                type="text"
                                                value={episode.name}
                                                onChange={(e) => this.handleInput(index,e.target.value,'name')}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                size="small"
                                                fullWidth
                                                variant="outlined"
                                                label={physically === "ebook" ? Translate.chapterDescription : Translate.epDescription}
                                                type="text"
                                                multiline
                                                minRows={2}
                                                value={episode.description}
                                                onChange={(e) => this.handleInput(index,e.target.value,'description')}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <FieldCounterWithoutBar length={!!episode.description ? episode.description.length : 0} max={1000}/>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={3} style={{textAlign:"center"}}>
                                    <SubTitle>{physically === "ebook" ? Translate.chapterThumbnail : Translate.epThumbnail}</SubTitle>
                                    <SingleImageChooser
                                        primary
                                        onChange={(thumbnail) => this.handleInput(index,thumbnail,'thumbnail')}
                                        initial={episode.thumbnail}
                                    />
                                    <GetConfirmationText
                                        tooltip={physically === "ebook" ? Translate.removeChapter : Translate.removeEpisode}
                                        className={this.classes.link}
                                        size="small"
                                        style={{
                                            cursor:"pointer",
                                            color: "rgb(255, 84, 81)",
                                            marginTop:20,
                                            borderRadius: 6,
                                        }}
                                        handleAction={()=> this.handleRemoveEp(index)}
                                        color={this.props.primary_color}
                                    >
                                        {physically === "ebook" ? Translate.removeChapter : Translate.removeEpisode}
                                    </GetConfirmationText>
                                </Grid>
                            </Grid>
                        </Grid>
                    ))
                }
                <Grid item xs={12} style={{textAlign:"center"}}>
                    <Button
                        color="secondary"
                        size="small"
                        variant="contained"
                        onClick={() => this.handleAddNewEP()}
                        startIcon={<AddRoundedIcon/>}
                    >
                        {physically === "ebook" ? Translate.addNewChapter : Translate.addNewEpisode}
                    </Button>
                </Grid>
                <Grid item xs={12} >
                    <Alert severity="info">
                        {Translate.calculatedDuration}
                    </Alert>
                </Grid>
            </Grid>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(EpisodeMaker)));